import { z } from 'zod'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from '../errorHandler'

export const ProjectUserResponseSchema = z
  .object({
    userId: z.number(),
    firstName: z.string(),
    surname: z.string(),
    email: z.string()
  })
  .describe('ProjectUserResponse')

export const ProjectResponseSchema = z
  .object({
    projectId: z.number(),
    createdBy: z.number(),
    createdOnTsMs: z.number(),
    updatedBy: z.number(),
    updatedOnTsMs: z.number(),
    title: z.string(),
    description: z.string(),
    colourScheme: z.string(),
    members: z.array(ProjectUserResponseSchema)
  })
  .describe('ProjectResponse')

export const GetProjectsResponseSchema = z.array(ProjectResponseSchema).describe('GetProjectsResponse')

export type ProjectUserApiResponse = z.infer<typeof ProjectUserResponseSchema>
export type ProjectApiResponse = z.infer<typeof ProjectResponseSchema>

export async function getProjects(): Promise<Array<ProjectApiResponse>> {
  const res = await fetch('/api/projects/v2', {
    method: 'GET',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), GetProjectsResponseSchema)
}
